// use this function to convert ALL data attributes to
// react-compatible props
export default function getDataAttributeProps(element) {
  const props = {};
  for (let data in element.dataset) {
    if (element.dataset.hasOwnProperty(data)) {
      props[data] = element.dataset[data];
    }
  }
  return props;
}
